import { LookupService as NirvanaLookupService } from "@front-shared/services/lookup.service"

export class LookupService extends NirvanaLookupService {}
